import { GlossaryItem } from '@features/glossary/domain/glossary';
import { SHARED_GLOSSARY } from '@features/glossary/domain/shared-glossary';

export const GLOSSARY = {
  adSpend: SHARED_GLOSSARY.adSpend,
  attributionMetrics: {
    label: 'Attribution Metrics',
    definition:
      'Foot traffic measurement related to exposed users matched to category-based control group, can thereby be attributed to the effects of advertising. Attribution metrics include Incremental Lift and Incremental Visits.',
  },
  campaignEndDate: SHARED_GLOSSARY.campaignEndDate,
  campaignStartDate: SHARED_GLOSSARY.campaignStartDate,
  confidenceLevel: SHARED_GLOSSARY.confidenceLevel,
  dimension: SHARED_GLOSSARY.dimension,
  dimensionValue: SHARED_GLOSSARY.dimensionValue,
  flightDates: SHARED_GLOSSARY.flightDates,
  impression: SHARED_GLOSSARY.impression,
  incrementalReturnOnAdSpend: {
    label: 'Incremental Return on Ad Spend (IROAS)',
    definition:
      'The estimated incremental dollar amount of ad spend return across the measurement period.',
  },
  incrementalSales: SHARED_GLOSSARY.incrementalSales,
  incrementalSalesLift: SHARED_GLOSSARY.incrementalSalesLift,
  incrementalLift: {
    label: 'Incremental Visit Lift',
    definition:
      'The percentage increase in the number of visits by the exposed group compared to the control. Measuring if the number of visits of the exposed users is greater than the number of visits in the category-based control group.',
  },
  incrementalVisits: {
    label: 'Incremental Visits',
    definition:
      'The number of visits by exposed users that can be attributed to the effects of advertising.',
  },
  locationVisits: {
    label: 'Location Visits',
    definition:
      'Foot traffic is measured by the number of post-exposure visits to specific, physical locations measured in the campaign. Location visits are based on the number of observed visits after exposure to advertising (post-exposure visits). There are two metrics reported for location visits: ',
    subItems: {
      total: {
        label: 'Total',
        definition:
          'The number of post-exposure visits by a set of unique users during a specified time period.',
      },
      incremental: {
        label: 'Incremental',
        definition:
          'The number of Location Visits attributed to your ad campaign according to the Incremental Lift percentage.',
      },
    },
  },
  measurementEndDate: SHARED_GLOSSARY.measurementEndDate,
  measurementPeriod: {
    label: 'Measurement Period',
    definition:
      'The range of days for which impression and visitation data are included in a campaign measurement report, from the measurement start date to the end of the measurement end date.',
  },
  measurementStartDate: SHARED_GLOSSARY.measurementStartDate,
  multiTouchAttribution: SHARED_GLOSSARY.multiTouchAttribution,
  penetration: SHARED_GLOSSARY.penetration,
  penetrationLift: {
    label: 'Penetration Lift',
    definition:
      'Measures the percentage increase in lift in the Penetration by the exposed compared to the control.',
  },
  postCampaignMeasurementPeriod: {
    label: 'Post-Campaign Measurement Period',
    definition:
      'The period after the Campaign End Date used to observe visitation data. In a standard campaign, this period is 14 days.',
  },
  returnOnAdSpend: SHARED_GLOSSARY.returnOnAdSpend,
  salesRate: SHARED_GLOSSARY.salesRate,
  timeToFirstVisit: {
    label: 'Time To First Visit',
    definition:
      'The number of days between the first ad exposure and the first visit to a physical location, shown as a percentage of visitors for each duration. The percentage shown on day 0 is a time to first visit of less than one day.',
  },
  totalProjectedSales: {
    label: 'Total Projected Sales',
    definition:
      'The total post-exposure sales by a set of unique users during a specified time period.  This includes in-store and e-commerce (online) sales.',
  },
  totalProjectedVisits: {
    label: 'Total Projected Visits',
    definition:
      'The total post-exposure visits by a set of unique users during a specified time period.',
  },
  transactionRate: SHARED_GLOSSARY.transactionRate,
  transactionRateLift: {
    label: 'Transaction Rate Lift',
    definition:
      'Measures the percentage increase in lift in the Transaction Rate by the exposed compared to the control.',
  },
  transactionSize: {
    label: 'Transaction Size',
    definition: 'The average dollar per purchase during the measurement period',
  },
  transactionSizeLift: {
    label: 'Transaction Size Lift',
    definition:
      'Measures the percentage increase in lift in the Transaction Size by the exposed compared to the control.',
  },
  uniqueUser: SHARED_GLOSSARY.uniqueUser,
  usersMatchedForAttribution: SHARED_GLOSSARY.usersMatchedForAttribution,
  visit: {
    label: 'Visit',
    definition:
      'A single event wherein a user has been observed within a prescribed boundary of a physical location.',
  },
} as const satisfies Record<string, GlossaryItem>;
